import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const Index = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.document.title = t("settings");
  }, [t]);

  //Change language
  const _changeLanguage = (lang) => {
    localStorage.setItem("language", lang);
    i18n.changeLanguage(lang);
  };

  return (
    <main className="mt-5">
      <p className="p mid-text">
        <span>{t("settings")}</span>
      </p>
      <div className="px-2 mb-2">
        <select
          className="form-select bg-light border-0"
          onChange={(event) => _changeLanguage(event.target.value)}
          defaultValue="All"
        >
          <option disabled value="All">
            {t("language") === "en" ? "اللغة" : "Language"}
          </option>
          <option value="en">English</option>
          <option value="ar">العربية</option>
        </select>
      </div>
    </main>
  );
};

export default Index;
